import Modal from "/WebInterface/new-ui/modules/modal.js";
// import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import SearchTemplate, { searchPollingTemplate } from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { searchResultClearTemplate } from "/WebInterface/new-ui/assets/js/app/templates/filter-section.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

export const initSearch = (args) => {
  const handleSearch = async () => {
    // const searchFormLoader = new Loader({parentElement: _$("#modal_search-form .modal-card").el()});
    const formData = utils.serializeInputs(searchDialog.root, false, true);
    const c2f = utils.cookie.get("currentAuth");
    let pollingRequest;
    let continuePolling = true;

    const dialog = new Modal({
      parent: _$("#modal_search-form .modal-card").el(),
      showHeader: false,
      hasFooter: false,
      body: searchPollingTemplate({}),
      extraClasses: ["poll-search-status-modal"],
    });

    _$("#abortSearchAction").on("click", () => {
      continuePolling = false;
      searchRequest.abort();
      pollingRequest?.abort();
      dialog?.hide(true);
    });

    const pollSearchStatus = async () => {
      pollingRequest = ajax
        .call({
          data: {
            command: "getSearchStatus",
            c2f,
          },
        })
        .then((resp) => {
          if (!continuePolling) {
            return;
          }

          const xml = new DOMParser().parseFromString(resp, "text/xml");
          const response = utils.xmlToJson(xml);
          const result = response?.commandResult?.response;

          const info = result?.split("/");
          const min = info[0] || 0;
          const max = info[1] || 1;

          const progress = _$(searchDialog.root).find(
            ".poll-search-status-progress"
          );
          progress.attr("value", min);
          progress.attr("max", max);

          setTimeout(() => {
            pollSearchStatus();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    pollSearchStatus();

    const startDate = formData.date1_value;
    const endDate = formData.date2_value;
    const searchRequest = ajax
      .call({
        data: {
          command: "search",
          c2f,
          ...formData,
          path: args.curPath,
          date1_value: startDate
            ? flatpickr.formatDate(
                flatpickr.parseDate(startDate, dateFormat),
                "m/d/Y"
              )
            : "",
          date2_value: endDate
            ? flatpickr.formatDate(
                flatpickr.parseDate(endDate, dateFormat),
                "m/d/Y"
              )
            : "",
          date1_value_display: startDate,
          date2_value_display: endDate,
        },
        timeout: 10000000,
      })
      .then((response) => {
        if (!continuePolling) {
          return;
        }

        const { listing, privs } = response;

        if (listing) {
          const manipulatedList = listing.map((item) => {
            const id = utils.getUId();
            return {
              ...item,
              privs: item.privs || privs,
              preview: parseInt(item.preview),
              mediaInfo: utils.isMedia(item.name),
              id: `${id}`,
              treeIds: `${id}`,
              paddingLeft: 12,
              ariaExpanded: false,
              isChecked: false,
              canPreventExpand: true,
            };
          });

          _$("#searchResultNotification").html(
            searchResultClearTemplate({
              clearText: t("clear"),
              showingSearchResultText: t("showingSearchResult"),
            })
          );

          _$("#search-result-clear-button").on("click", () => {
            _$("#searchResultNotification").html("");
            store.dispatch("refreshListing");
          });

          store.dispatch("setSearchFilterDetails", {
            ...formData,
            isSearchFilterActive: true,
          });
          store.dispatch("setFileListing", manipulatedList);
        }
        searchDialog.hide(true);
      })
      .fail((error) => {
        console.log(error);
      })
      .always(() => {
        continuePolling = false;
        // searchFormLoader.deleteLoader();
      });
  };

  // Setting date picker and their values
  const customDateFormat = utils.getUserCustomizationValue(
    "DATE_FORMAT_TEXT",
    true
  );

  const searchDialog = new Modal({
    title: "Search",
    body: SearchTemplate({ dateFormatText: customDateFormat || "mm/dd/yyyy" }),
    uniqueId: "search-form",
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["primary-button", "is-bordered", "mr-3"],
        onClick: () => {},
      },
      {
        label: "startSearch",
        close: false,
        classes: ["primary-button"],
        onClick: handleSearch,
      },
    ],
    minWidth: "800px",
    onBeforeHide: () => {
      const formData = utils.serializeInputs(searchDialog.root, false, true);
      let updatedSearchFilterDetails = store.searchFilterDetails;

      store.dispatch("setSearchFilterDetails", {
        ...updatedSearchFilterDetails,
        ...formData,
        hasOpened: true,
      });
    },
  });

  _$("#searchModalForm").on("submit", (e) => {
    e.preventDefault();
    handleSearch();
  });

  // customizations related to value
  if (!store.searchFilterDetails.hasOpened) {
    const {
      searchDefaultType,
      searchDefaultModifiedBefore,
      searchDefaultModifiedAfter,
      searchDefaultSize,
    } = store.userInfo.userCustomizations;

    let updatedSearchFilterDetails = store.searchFilterDetails;

    const updateSearchFilterDetails = (data = {}) => {
      updatedSearchFilterDetails = {
        ...updatedSearchFilterDetails,
        ...data,
      };
    };

    const searchDefaultExactMatch = utils.getUserCustomizationValue(
      "searchDefaultExactMatch"
    );
    updateSearchFilterDetails({ exact: searchDefaultExactMatch });

    if (searchDefaultModifiedAfter) {
      updateSearchFilterDetails({
        date1: "true",
        date1_action: "after",
        date1_value: searchDefaultModifiedAfter.value,
      });
    }

    if (searchDefaultModifiedBefore) {
      updateSearchFilterDetails({
        date2: "true",
        date2_action: "before",
        date2_value: searchDefaultModifiedBefore.value,
      });
    }

    if (searchDefaultType) {
      updateSearchFilterDetails({
        type1: "true",
        type1_action: searchDefaultType.value === "dir" ? "folder" : "file",
      });
    }

    if (searchDefaultSize) {
      if (
        typeof searchDefaultSize.value === "string" &&
        (searchDefaultSize.value.charAt(0) === "<" ||
          searchDefaultSize.value.charAt(0) === ">")
      ) {
        updateSearchFilterDetails({
          size1: "true",
          size1_action:
            searchDefaultSize.value.charAt(0) === "<"
              ? "smaller than"
              : "bigger than",
          size1_value: searchDefaultSize.value.substr(1),
        });
      }
    }

    store.dispatch("setSearchFilterDetails", {
      ...updatedSearchFilterDetails,
      hasOpened: true,
    });
  }

  const searchFilterDetails = store.searchFilterDetails;

  // Setting value for input elements in search dialog

  let dateFormat = null;
  if (customDateFormat) {
    dateFormat = utils.dateStringFormat({ format: customDateFormat });
  }

  const options = { dateFormat: dateFormat || "m/d/Y" };

  const dateInputs = [
    {
      id: "modified-1",
      options: { ...options, defaultDate: searchFilterDetails.date1_value },
    },
    {
      id: "modified-2",
      options: { ...options, defaultDate: searchFilterDetails.date2_value },
    },
  ];

  dateInputs.forEach(({ id, options }) => {
    const calendar = flatpickr(`#${id}`, options);
    calendar.setDate(options.defaultDate);
  });

  // Setting values for remaining inputs other than dates
  const modalBody = searchDialog.modal.body;
  const inputElementsSearchDialog = modalBody.querySelectorAll(
    "select,input:not([class*='date-input'])"
  );

  inputElementsSearchDialog.forEach((input) => {
    if (searchFilterDetails[input.name]) {
      if (input.type === "checkbox") {
        input.checked = true;
      }
      if (input.type === "radio") {
        if (input.value === searchFilterDetails[input.name]) {
          input.checked = true;
        }
      } else {
        input.value = searchFilterDetails[input.name];
      }
    }
  });
};
